// export const Card = ({ children, className = '' }) => {
//   return (
//     <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-6 ${className}`}>
//       {children}
//     </div>
//   )
// }

export const Card = ({ children, className = '' }) => {
  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-200 p-4 md:p-6 ${className}`}
    >
      {children}
    </div>
  )
}
